import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAIZerlQZTt4CndN6JNFNyTNczMwUtbFlI",
  authDomain: "myriadle.firebaseapp.com",
  projectId: "myriadle",
  storageBucket: "myriadle.appspot.com",
  messagingSenderId: "1067944460986",
  appId: "1:1067944460986:web:1b1fb7124272725e2ab883",
  measurementId: "G-Z7MQ62VFLT",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore();
